import type { IBank } from '~/components/entity/bank/types'

export function getBankDetailsList(
  bank: IBank | undefined
): { name: string; description: string }[] {
  if (!bank) return []

  const details: { name: string; description: string }[] = []

  type TDetailsList = Record<string, string>

  const fieldsToExtract: TDetailsList = {
    official_title: 'widget.bank_page.details.fields.official_title',
    account_number: 'widget.bank_page.details.fields.account_number',
    bik: 'widget.bank_page.details.fields.bik',
    swift: 'widget.bank_page.details.fields.swift',
    giin: 'widget.bank_page.details.fields.giin',
    inn: 'widget.bank_page.details.fields.inn',
    ukkn: 'widget.bank_page.details.fields.ukkn',
    license: 'widget.bank_page.details.fields.license'
  }

  for (const field in fieldsToExtract) {
    const label = fieldsToExtract[field]
    const value = bank[field as keyof IBank]

    if (value !== undefined && value !== null && value !== '') {
      details.push({
        name: label,
        description: String(value)
      })
    }
  }

  return details
}
